module.exports = __webpack_public_path__ + "static/media/24.dbbf55d3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sports/svg/24.svg
// module id = 136
// module chunks = 0